// @flow
import React, { type Element } from 'react';
// import { Helmet } from 'react-helmet';

import Link from 'app/common/lib/link';
import { APP_ACCESS } from 'app/common/constants/services';
import StudentsSelector from 'app/components/StudentsSelector';
import DatePicker from 'app/common/ui/DatePicker';
import Sticky, { withStickyRows } from 'app/common/components/Sticky';
import { BannerContent } from 'app/common/components-next/banner';

import SubscribePlease from './SubscribePlease';
import SettingsContainer from '../../../containers/SettingsContainer';
import PageNav from '../../_ui/PageNav';
import styles from './Passages.scss';
import tableStyles from './table.scss';


// Символьное имя данного приложения
export const appString = APP_ACCESS;

type Props = {
  params: {
    date?: string,
    date2?: string,
    id: string,
  },
  children: Element<any>,
  // title: string,
  header: string,
  sDate: string,
  urlPrev: string,
  urlNext: string,
  isDisabledNext: boolean,
  isPagination: boolean,
  isSubscribed: boolean,
  handleDisabledDaysInDatePicker: Function,
  handleChangeDay: Function,
  handleChangeRange: Function,

  N: number,
  page: number,
  begin: number,
  count: number,
  perPageItems: number,
  handleChangePage: Function,

  loading: boolean,
  isExternal: boolean,

  t: (s: string, t: Object) => string,
}

const Passages = ({
  params: { date, date2, id },
  children,
  // title,
  header,
  sDate,
  urlPrev,
  urlNext,
  isDisabledNext,
  isPagination,
  isSubscribed,
  handleDisabledDaysInDatePicker,
  handleChangeDay,
  handleChangeRange,

  N,
  page,
  begin,
  count,
  perPageItems,
  handleChangePage,

  loading,
  isExternal,

  t,
}: Props) => { // eslint-disable-line

  return (
    <div className={styles.container}>
      {/* <Helmet>
        <title>{title}</title>
      </Helmet>
      <h1 className={styles.h1}>
        {t(`subs:${appString}`)}
      </h1> */}

      <Sticky
        number={1}
        className={styles.header}
      >
        <div>
          <div className={styles.filterBar}>
            <StudentsSelector />
          </div>

          { /* Таблица с данными */ }
          {isSubscribed
            && <div className={styles.dataHeader}>
              <div className={styles.headerText}>
                {isExternal
                  ? t('last_passage')
                  : header}
              </div>
              {!isExternal
                && <div className={styles.dateSelector}>
                  <Link to={urlPrev} className={styles.arrow}>&#10094;</Link>
                  <div className={styles.dateString}>{sDate}</div>
                  {isDisabledNext
                    ? <Link className={`${styles.arrow} ${styles.disabled}`} to="#none">&#10095;</Link>
                    : <Link className={styles.arrow} to={urlNext}>&#10095;</Link>}
                  <DatePicker
                    day={date && new Date(date)}
                    day2={date2 && new Date(date2)}
                    onChangeDay={handleChangeDay}
                    onChangeRange={handleChangeRange}
                    className={styles.datePicker}
                    double
                    disabledDays={handleDisabledDaysInDatePicker}
                  />
                  <SettingsContainer dataKey="passages" />
                </div>}
            </div>}
        </div>
      </Sticky>

      <Sticky
        number={2}
        trackState
        className={styles.tableHeader}
        stickyClassName={styles.shadow}
      >
        <div className={styles.contentHeader}>
          {isSubscribed
            && <table className={tableStyles.table}>
              <thead>
                <tr>
                  {!!date2 && <th className={tableStyles.tDate}>{t('column_title_data')}</th>}
                  <th className={tableStyles.tPlace}>{t('column_title_place')}</th>
                  <th className={tableStyles.tAct}>{t('column_title_action')}</th>
                  <th className={tableStyles.tTime}>{t('column_title_time')}</th>
                  <th>{t('column_title_message')}</th>
                </tr>
              </thead>
            </table>}
        </div>

        <BannerContent
          placeId="d099e4c6-f44b-42ef-b5f9-a1d52c27dee5"
          className={styles.bannerPlaceholder}
          displayAsPlaceholder
          height={0}
        />

      </Sticky>

      <div className={styles.content}>
        <div className={styles.contentTable}>
          {children}
        </div>

        <BannerContent
          leaveContainerOnEmpty
          refreshOnMount
          className={styles.bannerContent}
          placeId="d099e4c6-f44b-42ef-b5f9-a1d52c27dee5"
        />

      </div>

      {isExternal
        && !loading
        && <SubscribePlease
          studentId={id}
          service={appString}
          className={styles.subscribeWarning}
        />}

      {!loading && isSubscribed && isPagination
        && <Sticky
          mode="bottom"
          number={-1}
          stickyClassName={styles.shadowTop}
        >
          <div className={styles.footer}>
            <PageNav
              text={t('pagination', {
                begin,
                end: (begin + N) - 1,
                total: count,
              })}
              page={page}
              total={count}
              perPage={perPageItems}
              handleChangePage={handleChangePage}
            />
          </div>
        </Sticky>}

      {!isPagination && <div className={styles.footerEmpty} />}

    </div>
  );
};

export default withStickyRows(Passages);
